app.service('shopsView',function(regionSVG, front) {
	var $self, $regionSelect, $departmentSelect, $citiesList, $citiesLinks, $shopsArea, $selectList;
	var filter='';

	function setElements(){
		$self = $("#shops");
		$citiesList=$('#cities-list', $self);
		$shopsArea=$('#shops-area', $self);
		$selectList=$('#select-list', $self);
		$citiesLinks=$('.js-shop-list', $self);
	}
	function getSelect(ajaxData){
		if(front.katalog){
			$selectList.addClass('loading');
			$.ajax({
				url:'/shop-province-department.ltr',
				data: ajaxData,
				complete:function(){
					$selectList.removeClass('loading');
					$selectList.find('.select3-input').select3();
					setEventsSelect();
				},
				success: function(data){
					$selectList.html(data);
				}
			});
		}
	}
	function getData(){
		var data={};
		if($regionSelect.val()!==''){
			data.province_code=$regionSelect.val();
		}
		if($departmentSelect.val()!==''){
			data.department=$departmentSelect.val()
		}
		return data;
	}
	function setEventsSelect(){
		$regionSelect=$('#shops-region', $self);
		$departmentSelect=$('#shops-department', $self);

		$regionSelect.change(function(){
			var data=getData();
			getSelect(data);
			showMap(data);
			getCities(data);
			if(front.katalog){
				getShops(data);
			}else{
				$shopsArea.empty();
			}
		});
		$departmentSelect.change(function(){
			var data=getData();
			getSelect(data);
			getCities(data);
			getShops(data);
			$citiesLinks.removeClass('active');
		});
	}
	function setEvents(){
		setEventsSelect();
		$self.on('click','.js-shop-list',function(){
			UA.pageview('/sklepy/'+$(this).data('name')+'.bhtml');
			getShops({city_code:$(this).data('code')},true);
		});
	}
	function showMap(ajaxData) {
		var region=ajaxData.province_code;
		if(region>-1){
			if(region!==''){
				UA.pageview('/sklepy/wojewodztwo-' + $('#shops-search .select3-selected-item').text().trim()+'.bhtml');
			}
			regionSVG.select(region);
		}
	}
	function getCities(ajaxData) {
		var data=$.extend({
			action: 'get_cities',
		},ajaxData);
		if(ajaxData.province_code || ajaxData.department){
			$citiesList.addClass('loading');
			$.ajax({
				url:'/shops-refresh-element.ltr',
				data: data,
				complete:function(){
					$citiesList.removeClass('loading');
				},
				success: function(data){
					$citiesList.html(data);
					$citiesLinks=$('.js-shop-list', $self);
					getBreadcrumb(ajaxData.province_code);
				}
			});
		}else{
			$citiesList.empty();
		}
	}
	function getShops(ajaxData,scroll) {
		if(ajaxData.city_code || ajaxData.province_code || ajaxData.department){
			if($citiesLinks && ajaxData.city_code){
				$citiesLinks.removeClass('active').filter('[data-code='+ajaxData.city_code+']').addClass('active');
			}
			$shopsArea.addClass('loading');
			if(scroll){
				$.scrollTo($shopsArea, 800 );
			}
			var data=$.extend({
				action: 'get_shops'
			},ajaxData);
			$.ajax({
				url:'/shops-refresh-element.ltr',
				cache: true,
				data: data,
				complete:function(){
					$shopsArea.removeClass('loading');
				},
				success: function(data){
					$shopsArea.html(data);
					getBreadcrumb($regionSelect.val());
				}
			});
		}else{
			$shopsArea.empty();
		}
	}
	function getBreadcrumb(region) {
		if(front.euro && region){
			$.ajax({
				url:'/shops-refresh-element.ltr',
				data: {
					action: 'get_breadcrumb',
					province_code: region
				},
				success: function(data){
					$('#breadcrumb').html(data);
				}
			});
		}
	}

	function init() {
		setElements();
		setEvents();
		regionSVG.init({
			selectCb:function(e){
				var data={
					province_code: $(e).attr('data-code')
				};
				getSelect(data);
				getCities(data);
				$shopsArea.empty();
			}
		});
	}
	return {
		init:init
	};
});
